/*
 * Big B slideshow — whole-slide click
 *
 * No overlay <a>, no z-index, no pointer-events. The slide markup stays
 * exactly as Refresh renders it; the slide just carries a data attribute:
 *
 *   <div class="slideshow__slide ..." data-slide-link="{{ block.settings.link }}">
 *
 * Clicking anywhere on that slide navigates to the link, unless the click
 * landed on a real link or button inside the slide (those keep doing their
 * own thing). Cmd/Ctrl/middle-click opens a new tab. Swipes on mobile don't
 * fire click events, so they're unaffected; a mouse drag of more than a few
 * pixels is ignored too. Does nothing inside the theme editor.
 *
 * Load from slideshow.liquid:
 *   <script src="{{ 'slideshow-slide-link.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var DRAG_TOLERANCE = 8;
  var downX = 0;
  var downY = 0;

  document.addEventListener('pointerdown', function (event) {
    downX = event.clientX;
    downY = event.clientY;
  });

  document.addEventListener('click', function (event) {
    var slide = event.target.closest('.slideshow__slide[data-slide-link]');
    if (!slide) return;

    // Let real links and buttons inside the slide behave normally
    if (event.target.closest('a, button')) return;

    // Ignore mouse drags
    if (
      Math.abs(event.clientX - downX) > DRAG_TOLERANCE ||
      Math.abs(event.clientY - downY) > DRAG_TOLERANCE
    ) {
      return;
    }

    var url = slide.getAttribute('data-slide-link');
    if (!url) return;

    event.preventDefault();

    var newTab =
      event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1;

    if (newTab) {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.assign(url);
    }
  });

  // Middle-click doesn't fire 'click' in all browsers; handle it via auxclick
  document.addEventListener('auxclick', function (event) {
    if (event.button !== 1) return;
    var slide = event.target.closest('.slideshow__slide[data-slide-link]');
    if (!slide || event.target.closest('a, button')) return;
    var url = slide.getAttribute('data-slide-link');
    if (!url) return;
    event.preventDefault();
    window.open(url, '_blank', 'noopener');
  });
})();
